import { Component } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-account-setup',
  standalone: true,
  imports: [],
  templateUrl: './account-setup.component.html',
  styleUrl: './account-setup.component.scss'
})
export class AccountSetupComponent {
  constructor(private readonly authService: AuthService) {}
  
    ngOnInit() {
      if (!sessionStorage.getItem('hasRefreshed')) {
        sessionStorage.setItem('hasRefreshed', 'true');
        window.location.reload();
      } else {
        sessionStorage.removeItem('hasRefreshed');
      }
      this.redirectToAzureADPasswordReset();
    }
  
    redirectToAzureADPasswordReset() {
      this.authService.initiateAccountSetup();
    };
  
}
